import { useTranslation } from "react-i18next";

import CopyIcon from "@mui/icons-material/ContentCopyRounded";
import { Box, IconButton, Typography } from "@mui/material";

interface Props {
  activityId: string;
}

export function ActivityTraceIdCopy({ activityId }: Props) {
  const { t } = useTranslation();

  const handleCopy = async () => {
    await navigator.clipboard.writeText(activityId);
  };
  return (
    <Box sx={{ display: "flex", gap: 0.5 }}>
      <IconButton
        size="small"
        onClick={() => void handleCopy()}
        aria-label={t("common.copyMessage", { message: activityId })}
        sx={{ p: 0, height: "18px", width: "18px" }}
      >
        <CopyIcon fontSize="inherit" />
      </IconButton>
      <Typography variant="caption" color="black">
        {activityId}
      </Typography>
    </Box>
  );
}
